export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export const CLOUDFRONT_URL = 'https://dj6wjgdqr93aw.cloudfront.net/';
